<template>
    <div>
        <div class="container mt-4 mb-4">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'federal'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2">Reglamentos</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!-- AREA DE ARCHIVOS -->
                    <a href="http://www.diputados.gob.mx/LeyesBiblio/regley/Reg_LFTAIPG.pdf" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Reglamento de la Ley Federal de Transparencia y Acceso a la Información Pública Gubernamental </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Reglamentos/Comite.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Reglamento del Comité de Vigilancia del Sistema de Participaciones en Ingresos Federales </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                     <a :href="urlServe+'marco-juridico/Federal/informacion/Reglamentos/Organismos.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Reglamento Interior de los Organismos del Sistema Nacional de Coordinación Fiscal </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://www.diputados.gob.mx/LeyesBiblio/regley/Reg_LFPRH_270120.pdf" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Reglamento de la Ley Federal de Presupuesto y Responsabilidad Hacendaria </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>

                                   
                </div>
                
                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes">
                        <div class="sec_imagen"> 
                            <img src="@/assets/imagenes/reglas.jpg" alt="">  
                        </div>
                    </div>
                    
                    
                </div>
            </div>
            <div class="text-aviso my-5">
                <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
            </div>
        </div>
    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        atrasComponent,
        botonAtras
    }
}
</script>

<style scoped>
    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        /* line-height: 20px; */
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    .text-aviso h5 {      

        font-size: 1rem;
        font-weight: 400;
        /* line-height: 20px; */
    }
    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .resaltado-vino{
        color: #560F2C;
        font-weight: 500;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }
}

</style>